import { render, staticRenderFns } from "./NotaFiscal.vue?vue&type=template&id=0af1dce4&scoped=true&lang=pug"
import script from "./NotaFiscal.vue?vue&type=script&lang=js"
export * from "./NotaFiscal.vue?vue&type=script&lang=js"
import style0 from "./NotaFiscal.vue?vue&type=style&index=0&id=0af1dce4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af1dce4",
  null
  
)

export default component.exports